<template>
  <div>
    <van-nav-bar
      title="收货地址"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form class="address_form" @submit="onSubmit">
      <div class="top_round">
        <van-field
          v-model="userName"
          placeholder="请输入姓名"
          label="姓　　名："
          name="userName"
        />
        <van-field
          v-model="tel"
          placeholder="请输入手机号"
          type="tel"
          label="电　　话："
          name="tel"
          :rules="[{ pattern, message: '请输入正确的手机号' }]"
        />
        <van-field
          v-model="fieldValue"
          is-link
          readonly
          label="地　　区："
          placeholder="输入省/市/区/街道"
          @click="show = true"
        />
        <van-field
          v-model="detailAddress"
          label="详细地址："
          placeholder="街道门牌、楼层房间号等信息"
          name="detailAddress"
        />
      </div>
      <div class="space"></div>
      <div class="top_round">
        <van-field readonly label="设为默认地址">
          <template #button>
            <van-switch size="18px" v-model="isDefault" @change="onChange" />
          </template>
        </van-field>
      </div>
      <div style="margin-top: 1.65rem">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>

    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="selectedAddress"
        title="请选择所在地区"
        :options="options"
        @close="show = false"
        @change="handleAddressChange"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>
<script>
import api from "../Api";
export default {
  mixins: [api],
  data() {
    return {
      userName: "",
      tel: "",
      pattern: /^1[3456789]\d{9}$/,
      detailAddress: "",
      //地址相关信息数据
      show: false,
      fieldValue: "",
      finalAddress: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      provinces: [],
      cities: [],
      districts: [],
      streets: [],
      selectedAddress: "",
      //value1-4表示选择的省市区街道代码
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      //是否默认地址
      isDefault: false,
    };
  },
  computed: {
    options() {
      return this.provinces.map((province) => ({
        text: province.province_name,
        value: province.province_code,
        children: this.cities
          .filter((city) => this.value1 === province.province_code)
          .map((city) => ({
            text: city.city_name,
            value: city.city_code,
            children: this.districts
              .filter((district) => this.value2 === city.city_code)
              .map((district) => ({
                text: district.area_name,
                value: district.area_code,
                children: this.streets
                  .filter((street) => this.value3 === district.area_code)
                  .map((street) => ({
                    text: street.street_name,
                    value: street.street_code,
                  })),
              })),
          })),
      }));
    },
  },
  created() {
    // 初始化省份数据
    this.getProvinces();
  },
  mounted() {},
  methods: {
    onChange(v) {
      this.isDefault = v;
    },

    async onSubmit(values) {
      //提交触发
      if (this.districts.length == 0) {
        this.value3 = "";
      }
      if (this.streets.length == 0) {
        this.value4 = "";
      }
      const response = await this.$Ajax("/shop/add-address", {
        provinceCode: this.value1,
        cityCode: this.value2,
        areaCode: this.value3,
        streetCode: this.value4,
        detailAddress: values.detailAddress,
        userName: values.userName,
        phone: values.tel,
        isDefault: this.isDefault ? 1 : 0,
      });
      if (response.code == 200) {
        this.$toast(response.msg);
        this.$router.back();
      }
    },

    async getProvinces() {
      // 调用获取省份数据的接口
      const response = await this.$Ajax("/shop/province", {});
      this.provinces = await response.data;
    },
    async getCities(provinceCode) {
      // 调用获取市数据的接口
      const response = await this.$Ajax("/shop/city", {
        provinceCode,
      });
      this.cities = await response.data;
    },
    async getDistricts(cityCode) {
      // 调用获取区数据的接口
      const response = await this.$Ajax("/shop/area", {
        cityCode,
      });
      if (response.data) {
        this.districts = await response.data;
      } else {
        this.districts = [];
        this.show = false;
        this.fieldValue = this.finalAddress;
      }
    },
    async getStreets(areaCode) {
      // 调用获取街道数据的接口
      const response = await this.$Ajax("/shop/street", {
        areaCode,
      });
      if (response.data) {
        this.streets = await response.data;
      } else {
        this.streets = [];
        this.show = false;
        this.fieldValue = this.finalAddress;
      }
    },
    handleAddressChange(value) {
      // 根据选择的结果来调用对应的接口
      this.finalAddress = value.selectedOptions
        .map((option) => option.text)
        .join("/");
      if (value.selectedOptions.length === 1) {
        this.value1 = value.value;
        this.getCities(value.value);
      } else if (value.selectedOptions.length === 2) {
        this.value2 = value.value;
        this.getDistricts(value.value);
      } else if (value.selectedOptions.length === 3) {
        this.value3 = value.value;
        this.getStreets(value.value);
      } else if (value.selectedOptions.length === 4) {
        this.value4 = value.value;
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.van-button--round) {
  background-color: rgba(0, 0, 0, 1);
  width: 16.05rem;
  height: 2.5rem;
  margin: 0 auto;
}

.popAddress {
  display: flex;
  justify-content: space-around;
}

.sure {
  width: 3rem;
  height: 1.5rem;
  color: #ffffff;
  font-size: 0.7rem;
  border-radius: 0.5rem;
  text-align: center;
  line-height: 1.5rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.438);
}

select {
  outline: none;
  width: 4.25rem;
  height: 1rem;
  margin-top: 1.25rem;
  border: 1px solid rgba(158, 158, 158, 0.452);
}

:deep(.van-nav-bar__title) {
  color: #000000;
  font-weight: bold;
  font-size: 0.8rem;
}

.van-form {
  padding-top: 0.6rem;
  margin: 2.5rem 0.75rem 0;
  .top_round {
    border-radius: 0.7rem;
    overflow: hidden;
  }
  .space {
    height: 0.6rem;
  }

  .van-cell {
    height: 2.5rem;
    padding: 0 0.6rem;
    align-items: center;
  }

  .van-switch--on {
    background-color: #9e9e9e;
  }
}

:deep(.van-field__label) {
  span {
    color: #000000;
  }
}
</style>
